import * as React from 'react'
import * as css from './ProjectsList.module.css'
import SanityBlock from './SanityBlock'
import Img from './Img'
import { MdArrowRightAlt } from 'react-icons/md'
import HexPattern from 'components/common/HexPattern'

/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */

const ProjectsList = ({ title, description, subtitle, items }) => {
	const [$active, set$active] = React.useState(0)
	const [$next, set$next] = React.useState(1)

	function prevItem() {
		set$active((c) => (c <= 0 ? items.length - 1 : c - 1))
		set$next((c) => (c <= 0 ? items.length - 1 : c - 1))
	}
	function nextItem() {
		set$active((c) => (c >= items.length - 1 ? 0 : c + 1))
		set$next((c) => (c >= items.length - 1 ? 0 : c + 1))
	}

	return (
		<section className="relative py-16 px-4 overflow-hidden">
			<header className="max-w-screen-md mx-auto text-center">
				<h2 className="h3 technical">{title}</h2>
				{subtitle && <p className="technical mt-4">{subtitle}</p>}
				{description && <p className="mt-8 leading-relaxed">{description}</p>}
			</header>

			<div className="relative max-w-screen-xl mx-auto grid lg:grid-cols-[2.5fr,1fr] gap-y-8 gap-x-16 items-center mt-16 md:px-4">
				{items?.map(({ name, _rawDescription, image }, key) => (
					<article className={css.item} hidden={$active !== key} key={key}>
						<Img className="grayscale" image={image} alt={name} />

						<div className={css.txt}>
							<h3 className="h2 mb-4">{name}</h3>
							<SanityBlock body={_rawDescription} />
						</div>
					</article>
				))}

				<div className="max-w-screen-sm mx-auto">
					<NextItem {...items[$next]} onClick={nextItem} key={$next} />

					<div className="flex justify-center gap-16 text-5xl text-ft-green">
						<button
							className="hover:text-ft-green-dark -scale-x-100"
							onClick={prevItem}
							aria-label="Previous item"
						>
							<MdArrowRightAlt />
						</button>
						<button className="hover:text-ft-green-dark" onClick={nextItem} aria-label="Next item">
							<MdArrowRightAlt />
						</button>
					</div>
				</div>
			</div>

			<HexPattern
				simple
				className="z-[-1] left-0 -translate-x-1/2 md:top-1/2 md:-translate-y-1/2 md:max-w-[50vw] <md:bottom-[25%]"
			/>
		</section>
	)
}

const NextItem = ({ name, image, onClick }) => (
	<figure
		className={`${css.next} cursor-pointer relative gradient-ft-green text-white`}
		onClick={onClick}
	>
		<Img className="opacity-10 <md:max-h-[8em]" image={image} alt={name} />
		<figcaption className="absolute left-0 top-0 m-8 <md:my-4">
			<span className="block mb-1 technical text-sm">Next:</span>
			<p className="technical-lg">{name}</p>
		</figcaption>
	</figure>
)

export default ProjectsList
